// TAS Flow — 223 özellik ve 34 modül için TR -> EN sözlüğü.
// Anahtarlar /app/frontend/src/data/tasFlowFeatures.js içindeki Türkçe isimlerle birebir aynıdır.

export const MODULE_EN = {
  "Platform & Genel": "Platform & General",
  "Yapay Zekâ & Otomasyon": "Artificial Intelligence & Automation",
  "İç Talepler & Ticket Yönetimi": "Internal Requests & Ticket Management",
  "Travel API — Sorgulama & Rezervasyon (KPLUS)": "Travel API — Search & Booking (KPLUS)",
  "Uçuş Yönetimi": "Flight Management",
  "Otel & Konaklama": "Hotel & Accommodation",
  "Araç Kiralama & Transfer": "Car Rental & Transfer",
  "Vize Yönetimi": "Visa Management",
  "Etkinlik / MICE": "Events / MICE",
  "Seyahat Politikası & Onay": "Travel Policy & Approval",
  "TAS Flow Pulse (Canlı İstatistik)": "TAS Flow Pulse (Live Statistics)",
  "TAS Flow Intelligence (Veri Analizi)": "TAS Flow Intelligence (Data Analytics)",
  "Raporlama & Dashboard": "Reporting & Dashboard",
  "Finans & Faturalama": "Finance & Invoicing",
  "İnsan Kaynakları — Giriş/Çıkış (PDKS)": "Human Resources — Time & Attendance",
  "CRM & Kurumsal Hesap": "CRM & Corporate Accounts",
  "Bildirim & İletişim": "Notifications & Communication",
  "Kullanıcı, Rol & Güvenlik": "Users, Roles & Security",
  "Entegrasyonlar": "Integrations",
  "Arayüz, Mobil & Kullanılabilirlik": "Interface, Mobile & Usability",
  "Sistem Yönetimi & Altyapı": "System Administration & Infrastructure",
  "Destek & SLA": "Support & SLA",
  "Görev, Takvim & İş Planı": "Tasks, Calendar & Work Planning",
  "Belge & Sözleşme Yönetimi": "Document & Contract Management",
  "Müşteri Self-Servis Portalı": "Customer Self-Service Portal",
  "Otomasyon Kuralları (No-Code)": "Automation Rules (No-Code)",
  "Kalite, Memnuniyet & Geri Bildirim": "Quality, Satisfaction & Feedback",
  "Seyahatçi Güvenliği & Duty of Care": "Traveller Safety & Duty of Care",
  "Sürdürülebilirlik & Maliyet Optimizasyonu": "Sustainability & Cost Optimisation",
  "Raporlama — Ek Rapor Tipleri": "Reporting — Additional Report Types",
  "Travel API — Ek Sorgu & Ekranlar (KPLUS)": "Travel API — Additional Searches & Screens (KPLUS)",
  "Bildirim & İletişim — Ek": "Notifications & Communication — Additional",
  "İK — Ek Özellikler": "HR — Additional Features",
  "Yönetim & Ölçeklenme": "Administration & Scaling",
};

export const FEATURE_EN = {
  "Tek merkezden operasyon paneli": "Single centralised operations console",
  "Rol tabanlı çok kullanıcılı yapı": "Role-based multi-user structure",
  "Kurumsal marka görünümü": "Corporate white-label branding",
  "Çoklu firma (multi-tenant) desteği": "Multi-company (multi-tenant) support",
  "Türkçe/İngilizce dil desteği": "Turkish / English language support",
  "Global arama": "Global search",
  "Favoriler & hızlı erişim": "Favourites & quick access",
  "Kişiselleştirilebilir çalışma ekranı": "Customisable workspace",
  "Etkinlik/işlem denetim izi audit log": "Activity & transaction audit log",
  "Karanlık/aydınlık tema": "Dark / light theme",
  "AI ile e-posta okuma": "AI-powered email reading",
  "Talep türü sınıflandırma": "Request type classification",
  "Doğru departmana otomatik yönlendirme": "Automatic routing to the right department",
  "Aciliyet/öncelik tespiti": "Urgency & priority detection",
  "E-postadan veri çıkarımı": "Structured data extraction from email",
  "Otomatik ticket oluşturma": "Automatic ticket creation",
  "E-posta thread eşleştirme": "Email thread matching",
  "Yanıt taslağı önerisi": "AI-suggested reply draft",
  "Dil algılama ve yönlendirme": "Language detection & routing",
  "Rutin taleplerde otomatik aksiyon": "Automatic action on routine requests",
  "AI özet": "AI summary",
  "Anomali/uyum uyarısı": "Anomaly & compliance alerts",
  "İç talep açma ekranı": "Internal request creation screen",
  "Talep kategorileri ve şablonlar": "Request categories & templates",
  "Ticket durum akışı": "Ticket status workflow",
  "Departman/uzman atama": "Department & specialist assignment",
  "SLA süre takibi": "SLA time tracking",
  "SLA aşım uyarısı & eskalasyon": "SLA breach alerts & escalation",
  "Talep içi mesajlaşma": "In-request messaging",
  "Dosya/ek yükleme": "File & attachment upload",
  "Talep birleştirme/bölme": "Merging & splitting requests",
  "Talep etiketleme": "Request tagging",
  "Talep geçmişi": "Request history",
  "Tekrar açma/yeniden atama": "Reopening & reassignment",
  "Toplu işlem": "Bulk actions",
  "Birleşik sorgu ekranı uçak+otel+araç": "Unified search screen (flight + hotel + car)",
  "Gerçek zamanlı uçuş sorgusu": "Real-time flight search",
  "Otel uygunluk & fiyat sorgusu": "Hotel availability & rate search",
  "Araç kiralama sorgusu": "Car rental search",
  "Çoklu tedarikçi karşılaştırma": "Multi-supplier comparison",
  "Çok bacaklı güzergâh arama": "Multi-leg itinerary search",
  "Gelişmiş filtreler": "Advanced filters",
  "Birleşik teklif sepet": "Unified quote basket",
  "Rezervasyon/opsiyon oluşturma": "Booking & option creation",
  "Fiyat/kur güncelleme yansıtma": "Live price & exchange rate updates",
  "Bilet/rezervasyon durum takibi PNR": "Ticket & booking status tracking (PNR)",
  "İptal/değişiklik işlemleri": "Cancellation & change handling",
  "Yurt içi uçuş yönetimi": "Domestic flight management",
  "Yurt dışı uçuş yönetimi": "International flight management",
  "Kurumsal tarife uygulama": "Corporate fare application",
  "Uçuş değişiklik yönetimi": "Flight change management",
  "Yolcu profili/tercih": "Traveller profiles & preferences",
  "Uçuş harcama raporu": "Flight spend report",
  "Kısa dönem konaklama": "Short-term accommodation",
  "Uzun dönem/proje konaklama": "Long-term & project accommodation",
  "Grup konaklama yönetimi": "Group accommodation management",
  "Politika uyumlu otel seçimi": "Policy-compliant hotel selection",
  "Konaklama harcama raporu": "Accommodation spend report",
  "Araç kiralama yönetimi": "Car rental management",
  "Şoförlü araç tahsisi": "Chauffeur-driven car allocation",
  "Havalimanı transfer yönetimi": "Airport transfer management",
  "VIP transfer & protokol": "VIP transfer & protocol services",
  "Etkinlik/grup transferi": "Event & group transfers",
  "Vize talep ekranı": "Visa request screen",
  "Evrak kontrol listesi": "Document checklist",
  "Randevu & başvuru takibi": "Appointment & application tracking",
  "Toplu grup vize süreci": "Bulk group visa process",
  "Vize süreç raporu": "Visa process report",
  "Etkinlik proje yönetimi": "Event project management",
  "Katılımcı seyahat yönetimi": "Attendee travel management",
  "Katılımcı kayıt yönetimi": "Attendee registration management",
  "Etkinlik bütçe takibi": "Event budget tracking",
  "Seyahat politikası tanımlama": "Travel policy definition",
  "Bütçe/limit kuralları": "Budget & limit rules",
  "Politika dışı uyarı": "Out-of-policy alerts",
  "Çok kademeli onay akışı": "Multi-level approval workflow",
  "Mobil onay": "Mobile approvals",
  "Tercih edilen tedarikçi kuralı": "Preferred supplier rules",
  "Canlı istatistik gösterge ekranı": "Live statistics dashboard",
  "Anlık talep/işlem sayaçları": "Real-time request & transaction counters",
  "Departman yoğunluk göstergesi": "Department workload indicator",
  "SLA performans göstergesi": "SLA performance indicator",
  "Günlük/haftalık trend grafikleri": "Daily & weekly trend charts",
  "Canlı bildirim akışı": "Live notification feed",
  "Hedef & KPI kartları": "Target & KPI cards",
  "Büyük ekran TV modu": "Big-screen TV mode",
  "Şirket verisi analiz alanı": "Company data analytics workspace",
  "Departman/proje bazlı analiz": "Department & project based analysis",
  "Tasarruf & verimlilik analizi": "Savings & efficiency analysis",
  "Zamanlanmış rapor e-postası": "Scheduled report emails",
  "Periyodik otomatik gönderim": "Recurring automatic delivery",
  "Alıcı listesi yönetimi": "Recipient list management",
  "Özelleştirilebilir rapor şablonları": "Customisable report templates",
  "Dönemsel karşılaştırma": "Period-over-period comparison",
  "Tahmin/öngörü analizi": "Forecasting & predictive analysis",
  "Rapor dışa aktarma Excel/PDF": "Report export (Excel / PDF)",
  "Yönetim dashboard'u": "Management dashboard",
  "Harcama raporları": "Spend reports",
  "Talep hacmi raporu": "Request volume report",
  "SLA/performans raporu": "SLA & performance report",
  "Özelleştirilebilir grafikler": "Customisable charts",
  "Zamanlanmış rapor gönderimi": "Scheduled report delivery",
  "Excel/PDF dışa aktarım": "Excel / PDF export",
  "Fatura & işlem takibi": "Invoice & transaction tracking",
  "Masraf merkezi dağıtımı": "Cost centre allocation",
  "Fatura-rezervasyon eşleştirme": "Invoice-to-booking reconciliation",
  "Cari/ödeme durumu": "Account balance & payment status",
  "Muhasebe entegrasyon aktarımı": "Accounting integration transfer",
  "Personel giriş-çıkış kaydı": "Employee clock-in / clock-out records",
  "Mesai özeti": "Working hours summary",
  "Geç kalma/erken çıkış hesabı": "Late arrival & early leave calculation",
  "Fazla mesai takibi": "Overtime tracking",
  "İzin/rapor/görevlendirme": "Leave, sick leave & assignment records",
  "Personel özlük kartı": "Employee record card",
  "Departman/ekip yapısı": "Department & team structure",
  "Vardiya planlama": "Shift planning",
  "PDKS raporları & dışa aktarım": "Time & attendance reports and export",
  "Kurumsal müşteri kayıtları": "Corporate customer records",
  "Firma bazlı kullanıcı yönetimi": "Company-based user management",
  "Anlaşma/tarife bilgileri": "Agreement & rate information",
  "İletişim geçmişi": "Communication history",
  "Firma bazlı raporlama": "Company-level reporting",
  "E-posta bildirimleri": "Email notifications",
  "Uygulama içi bildirim": "In-app notifications",
  "SMS bildirim": "SMS notifications",
  "WhatsApp bildirim": "WhatsApp notifications",
  "Hatırlatma/son tarih uyarısı": "Reminder & deadline alerts",
  "Rol tabanlı yetkilendirme": "Role-based authorisation",
  "Güvenli oturum yönetimi": "Secure session management",
  "İki adımlı doğrulama 2FA": "Two-factor authentication (2FA)",
  "Veri erişim kısıtı": "Data access restrictions",
  "İşlem denetim kayıtları": "Transaction audit records",
  "Parola politikası": "Password policy",
  "Travel API entegrasyonu": "Travel API integration",
  "E-posta sunucusu entegrasyonu": "Mail server integration",
  "Takvim entegrasyonu": "Calendar integration",
  "Muhasebe/ERP entegrasyonu": "Accounting / ERP integration",
  "PDKS cihaz/İK entegrasyonu": "Time-clock device & HR integration",
  "API erişimi dış sistemler": "API access for external systems",
  "Mobil uyumlu arayüz": "Mobile-responsive interface",
  "Hızlı filtre & sıralama": "Quick filtering & sorting",
  "Sürükle-bırak düzen": "Drag-and-drop layout",
  "Klavye kısayolları": "Keyboard shortcuts",
  "Erişilebilirlik uyumu": "Accessibility compliance",
  "Yönetici ayar paneli": "Administrator settings panel",
  "Kullanıcı & yetki yönetimi": "User & permission management",
  "Yedekleme & veri güvenliği": "Backup & data security",
  "Sistem sağlık izleme": "System health monitoring",
  "Veri dışa/içe aktarma": "Data import & export",
  "Çok ortamlı yapı": "Multi-environment setup",
  "7/24 operasyon desteği": "24/7 operational support",
  "Öncelikli destek hattı": "Priority support line",
  "Bilgi bankası/yardım": "Knowledge base & help centre",
  "Yerinde/uzaktan eğitim": "On-site & remote training",
  "Özel hesap yöneticisi": "Dedicated account manager",
  "Görev oluşturma & atama": "Task creation & assignment",
  "Görev durum takibi": "Task status tracking",
  "Kişisel yapılacaklar listesi": "Personal to-do list",
  "Operasyon takvimi": "Operations calendar",
  "Son tarih & hatırlatma": "Deadlines & reminders",
  "Tekrarlayan görevler": "Recurring tasks",
  "Takvim paylaşımı": "Calendar sharing",
  "Merkezi belge deposu": "Central document repository",
  "Sözleşme takibi": "Contract tracking",
  "Belge versiyonlama": "Document versioning",
  "Sözleşme yenileme uyarısı": "Contract renewal alerts",
  "Belge yetki/erişim kontrolü": "Document permission & access control",
  "E-imza/onay akışı": "E-signature & approval flow",
  "Kurumsal müşteri giriş portalı": "Corporate customer login portal",
  "Self-servis talep açma": "Self-service request creation",
  "Talep durumu izleme": "Request status tracking",
  "Rezervasyon geçmişi görüntüleme": "Booking history view",
  "Müşteri raporu indirme": "Customer report download",
  "Onay bekleyen işlemler": "Pending approval queue",
  "Kural motoru koşul→aksiyon": "Rule engine (condition → action)",
  "Otomatik atama kuralları": "Automatic assignment rules",
  "Otomatik etiketleme": "Automatic tagging",
  "Otomatik bildirim tetikleyici": "Automatic notification triggers",
  "Otomatik eskalasyon kuralı": "Automatic escalation rules",
  "Zamanlanmış otomatik işler": "Scheduled automated jobs",
  "Talep sonrası memnuniyet anketi": "Post-request satisfaction survey",
  "Puanlama & yorum toplama": "Rating & review collection",
  "Memnuniyet skoru raporu": "Satisfaction score report",
  "Şikâyet/itiraz yönetimi": "Complaint & dispute management",
  "Hizmet kalite göstergesi": "Service quality indicator",
  "Seyahatçi konum/seyahat kaydı": "Traveller location & trip records",
  "Acil durum bildirimi": "Emergency notification",
  "Seyahat risk uyarısı": "Travel risk alerts",
  "Yolcu iletişim listesi": "Traveller contact list",
  "Karbon ayak izi takibi": "Carbon footprint tracking",
  "Tasarruf fırsatı önerileri": "Savings opportunity recommendations",
  "Kullanılmayan bilet takibi": "Unused ticket tracking",
  "Harcama sızıntısı analizi": "Spend leakage analysis",
  "Aylık yönetici özet raporu": "Monthly executive summary report",
  "Tedarikçi performans raporu": "Supplier performance report",
  "Ödeme/tahsilat raporu": "Payment & collection report",
  "Kullanıcı aktivite raporu": "User activity report",
  "İptal/değişiklik raporu": "Cancellation & change report",
  "Rota/güzergâh analizi": "Route & itinerary analysis",
  "Bütçe-gerçekleşen kıyas": "Budget vs. actual comparison",
  "Özel filtreli rapor oluşturucu": "Custom filtered report builder",
  "Fiyat geçmişi/izleme": "Price history & monitoring",
  "Alternatif tarih önerisi": "Alternative date suggestions",
  "Kurumsal anlaşma fiyatı gösterimi": "Corporate negotiated rate display",
  "Uygunluk takvim görünümü": "Availability calendar view",
  "Sık kullanılan aramalar": "Saved & frequent searches",
  "Rezervasyon kural/koşul gösterimi": "Booking rules & conditions display",
  "Bildirim tercih yönetimi": "Notification preference management",
  "Toplu duyuru gönderimi": "Bulk announcement sending",
  "Şablonlu e-posta gönderimi": "Template-based email sending",
  "Bildirim geçmişi": "Notification history",
  "Personel self-servis": "Employee self-service",
  "Bordro için mesai aktarımı": "Working hours export for payroll",
  "Devamsızlık raporu": "Absence report",
  "Resmi tatil/çalışma takvimi": "Public holiday & working calendar",
  "Ziyaretçi giriş-çıkış kaydı": "Visitor check-in / check-out log",
  "Şirket/şube bazlı ayarlar": "Company & branch level settings",
  "Özel alan custom field tanımı": "Custom field definition",
  "İş akışı tasarımcısı": "Workflow designer",
  "Kota/kullanım limiti izleme": "Quota & usage limit monitoring",
  "Kullanım istatistikleri": "Usage statistics",
  "Çoklu para birimi desteği": "Multi-currency support",
  "Yolcu takibi desteği": "Passenger tracking support",
};
